import { seoResolver } from "../../modules/app-route";
import { AppRoutes } from "../../modules/app-route/models/app-route.model";

export const TERMINE_ROUTES: AppRoutes = [
    {
        path: "",
        loadComponent: () => import('./components/termine-carousel/termine-carousel.component').then(mod => mod.TermineCarouselComponent),
        outlet: "carousel"
    },
    {
        path: "",
        loadComponent: () => import('./components/termine-home/termine-home.component').then(mod => mod.TermineHomeComponent),
        title: 'YSTM - Termine',
        data: {
            meta: {
                description: 'Aktuelle Termine, Veranstaltungen und Ausbildungskurse des YSTM mit regelmäßiger Aktualisierung'
            }
        },
        resolve: { seo: seoResolver },
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full'
    }
];